import { InputArea } from '@wix/design-system';
import React from 'react';
import { EDIT_PANEL_HTML_INPUT } from '../../dataHooks.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const HtmlInputArea = ({
  placeholder,
  componentData,
  onChange
}) => {
  var _a;
  return /* @__PURE__ */ React.createElement(
    InputArea,
    {
      placeholder,
      dataHook: EDIT_PANEL_HTML_INPUT,
      value: (_a = componentData.html) != null ? _a : "",
      onChange: (e) => onChange(__spreadProps(__spreadValues({}, componentData), { url: void 0, html: e.target.value })),
      minHeight: "135px",
      autoSelect: true
    }
  );
};

export { HtmlInputArea };
//# sourceMappingURL=HtmlInputArea.js.map
